import { Block } from 'shared/components/Block';
import { TextInfoWithImage } from 'shared/components/TextInfoWithImage';
import { Wrapper } from 'shared/components/Wrapper';
import { LIST } from './constants';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const SobAndAgentsServices: React.FC = () => {
  return (
    <div>
      <Wrapper>
        <Element name={ENavigation.ServicesOwners}>
          <Block>
            <TextInfoWithImage list={LIST} image="layout" title="Сервисы для собственников и профессионалов рынка" />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
